import { put } from 'redux-saga/effects'
import { fetchRepliesByCompanyAction } from '../../handles'
import { fetchRepliesByCompany, FetchRepliesByCompanyResponse } from '../_http/reply'

export function* fetchRepliesByCompanySaga(action: ReturnType<typeof fetchRepliesByCompanyAction.request>) {
  const { companyId, operatorId } = action.payload
  try {
    const response: FetchRepliesByCompanyResponse = yield fetchRepliesByCompany({ companyId, operatorId })
    yield put(fetchRepliesByCompanyAction.success({ replies: response.replies }))
  } catch (error) {
    yield put(fetchRepliesByCompanyAction.failure())
  }
}
